export module Formatting {
    export class DateFormatting {
        private dateFormat = require("dateformat")
        date(date: any, ref?: any, withSeconds?: boolean) {
            if (!date) return null
            if (typeof ref == "undefined") ref = new Date()
            if (typeof ref == "number") ref = new Date(ref)
            if (typeof date == "number") date = new Date(date)
            var format = "yyyy-mm-dd HH:MM" + (withSeconds ? ":ss" : "")
            var dateStr = this.dateFormat(date, format)
            var refStr = ref ? this.dateFormat(ref, format) : ""
            if (dateStr.substring(0, 11) == refStr.substring(0, 11)) return dateStr.substring(11)
            else if (dateStr.substring(0, 5) == refStr.substring(0, 5)) return dateStr.substring(5)
            return dateStr
        }
        datePart(date: any, ref?: any) {
            if (typeof date == "undefined") return
            if (date == null) return
            if (typeof ref == "undefined") ref = new Date()
            if (typeof ref == "number") ref = new Date(ref)
            if (typeof date == "number") date = new Date(date)

            var dateStr = this.dateFormat(date, "yyyy-mm-dd")
            var refStr = ref ? this.dateFormat(ref, "yyyy-mm-dd") : ""
            if (dateStr.substring(0, 5) == refStr.substring(0, 5)) return dateStr.substring(5)
            return dateStr
        }
        time(date: any, withSeconds?: boolean) {
            if (!date) return null
            if (typeof date == "number") date = new Date(date)
            var format = "HH:MM" + (withSeconds ? ":ss" : "")
            return this.dateFormat(date, format)
        }
        dateCustomFormat(date: any, format: string) {
            if (typeof date == "undefined") return
            if (date == null) return
            if (typeof date == "number") date = new Date(date)
            var dateStr = this.dateFormat(date, format)
            return dateStr
        }
        duration(minutes: number) {
            minutes = Math.round(minutes)
            var sign = 1
            if (minutes < 0) {
                minutes = -minutes
                sign = -1
            }
            if (minutes >= 60) {
                if (minutes % 60 == 0) {
                    return (sign * minutes) / 60
                } else if (minutes % 30 == 0) {
                    return (sign * Math.round((minutes * 10) / 60)) / 10
                } else {
                    var hour: any = Math.floor(minutes / 60).toString()
                    var minute = Math.floor(minutes - hour * 60).toString()
                    if (minute.length == 1) minute = "0" + minute
                    return sign * hour + ":" + minute
                }
            } else if (minutes == 0) {
                return "0"
            } else {
                return (sign < 0 ? "-" : "") + "0:" + (minutes < 10 ? "0" : "") + minutes
            }
        }
        parseDuration(timeStr: string): number {
            timeStr = timeStr.replace(/,/, ".")
            if (timeStr.indexOf(":") >= 0) {
                var t = timeStr.split(":")
                var minutes = 0
                if (t[0].length > 0 && t[0] == "-") t[0] = "0"
                minutes = parseInt(t[0]) * 60
                if (timeStr.indexOf("-") == 0) minutes -= parseInt(t[1])
                else minutes += parseInt(t[1])
                return minutes
            }
            return Math.round(parseFloat(timeStr) * 60)
        }
        parseFloat(time: string): number | null {
            if (typeof time === "number") time = "" + time
            time.replace(/,/, ".")
            return parseFloat(time)
        }
        getDurationInMins(duration: string): number {
            let numericalDuration: number = 0
            let pauseSplit = duration.split(":")
            // hours and minutes conversion
            if (pauseSplit.length > 1) {
                // hh:mm
                numericalDuration += Number(pauseSplit[0]) * 60
                numericalDuration += Number(pauseSplit[1])
            } else {
                // just hours, whole or in "halves"
                numericalDuration += Number(pauseSplit[0]) * 60
            }
            return numericalDuration
        }

        isToday = (date: any) => {
            const today = new Date()
            if (typeof date == "number") date = new Date(date)
            return date.getDate() == today.getDate() &&
                date.getMonth() == today.getMonth() &&
                date.getFullYear() == today.getFullYear()
          }
    }
    export class Constants{
        jobsPerPage = 100
    }
}
